export default "__VITE_ASSET__9assONWX__"